(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/marionette/radio.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/marionette/radio.js'); 'use strict';

svs.player_login.radio = Backbone.Radio.channel('my-account');
let LoginModel;
svs.player_login.radio.reply('loginModel', () => {
  const serversideModels = svs.player_login.data || {};

  if (!LoginModel) {
    LoginModel = new svs.player_login.models.Login(serversideModels.login);
  }

  return LoginModel;
});
 })(window);